import React, { useState } from 'react';
import styled from 'styled-components';
import MenuItem from '@components/MenuItem';
import { TaxonomyTermsList } from './TaxonomyTerms';
import { Flex } from '@components/layout/Grid';
import { SelectedTermsComponent } from './SelectedTerms';
import VideoSettings from '@ecosystems/VideoSettings';
import { Trans } from '@lingui/react';
import { ChevronDown, SlidersHorizontal } from 'lucide-react';
import { FullTaxonomiesModal } from './FullTaxonomiesModal';

const TaxonomyBar = styled(Flex)<{ open: boolean }>`
  border-radius: 4px;
  background-color: rgba(241, 241, 241, 1);

  ${({ open }) =>
    open
      ? `
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      `
      : ''}
`;

const PRIMARY_TAXNOMIES = [
  'durations',
  'needs',
  'yoga-workout',
  'health',
  'instructors',
];

export const TaxonomiesFiltersDesktop = ({
  selectedTaxonomySlug,
  handleSelectTaxonomy,
  taxonomies,
  selectedTerms,
  handleSelectTerm,
  clearAll,
  clearTaxonomy,
}) => {
  const [isFiltersModalOpen, openFiltersModalOpen] = useState(false);
  const taxonomy =
    selectedTaxonomySlug &&
    taxonomies.find((taxonomy) => taxonomy.slug === selectedTaxonomySlug);

  const primaryTaxonomies = taxonomies.filter((tax) =>
    PRIMARY_TAXNOMIES.includes(tax.slug)
  );

  return (
    <React.Fragment>
      <TaxonomyBar open={selectedTaxonomySlug} alignItems="center" p={16}>
        <div className="flex-1 flex gap-4">
          <button
            className="flex items-center gap-1 text-dark border-0 border-r border-neutral-500/30 pr-4"
            onClick={() => openFiltersModalOpen(true)}
          >
            <SlidersHorizontal className="size-4" />
            <Trans id="videos_genres.taxonomies_bar.show_filters_modal" />{' '}
            <ChevronDown className="size-5 opacity-50" />
          </button>
          <div>
            {primaryTaxonomies.map((taxonomy) => {
              const _selectedTermsCount = selectedTerms[taxonomy.slug]?.length;
              return (
                <MenuItem
                  key={taxonomy.slug}
                  isSelected={taxonomy.slug === selectedTaxonomySlug}
                  onClick={() => {
                    handleSelectTaxonomy(taxonomy);
                  }}
                >
                  {taxonomy.name} &nbsp;{' '}
                  {_selectedTermsCount > 0 ? `(${_selectedTermsCount})` : null}
                </MenuItem>
              );
            })}
          </div>
        </div>
        <VideoSettings
          button_text={<Trans id="videos_genres.settings_button_desktop" />}
        />
      </TaxonomyBar>
      {/* accordion expanding list */}
      <TaxonomyTermsList
        taxonomy={taxonomy}
        selectedTaxonomySlug={selectedTaxonomySlug}
        onSelectTerm={handleSelectTerm}
        selectedTerms={selectedTerms}
        onClose={() => handleSelectTaxonomy('')}
      />
      {/* selected terms */}
      <SelectedTermsComponent
        selectedTerms={selectedTerms}
        taxonomies={taxonomies}
        handleSelectTerm={handleSelectTerm}
        clearAll={clearAll}
      />

      {isFiltersModalOpen ? (
        <FullTaxonomiesModal
          selectedTerms={selectedTerms}
          taxonomies={taxonomies}
          handleSelectTerm={handleSelectTerm}
          clearAll={clearAll}
          clearTaxonomy={clearTaxonomy}
          onClose={() => openFiltersModalOpen(false)}
        />
      ) : null}
    </React.Fragment>
  );
};
